import { useEffect, useState } from "react";

export const useFetchFulfillmentMethodMappings = () => {
    const [fulfillmentMethodMappings, setFulfillmentMethodMappings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (fulfillmentMethodMappings.length > 0 || isLoading) {
            return;
        }

        const fetchFulfillmentMethodMappings = async () => {
            setIsLoading(true);
            try {
                const rsp = await fetch(`api/SKUFulfillmentTypes/fulfillmentMethodMappings`);
                const mappings = await rsp.json();
                setFulfillmentMethodMappings(mappings);
            } catch (error) {
                console.error('Error fetching fulfillment method mappings:', error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchFulfillmentMethodMappings();
    }, [fulfillmentMethodMappings.length, isLoading]);

    return fulfillmentMethodMappings;
} 